export const servicesData = {
  advancedFacials: [
    // {
    //   id: "ultimate-radiance-renewal",
    //   name: "Ultimate Radiance Renewal",
    //   duration: "1 hour 30 mins",
    //   price: 110,
    //   description: `Indulge in our Ultimate Radiance Renewal facial, a truly transformative and all-encompassing spa experience that will leave your skin radiant, refreshed, and glowing with youthful vitality. This multi-step journey begins with a thorough cleanse to purify and prepare your skin. A gentle steam session follows, opening up your pores for the next step of exfoliation which eliminates impurities and dead skin cells.
    //   \nThis treatment includes a hand, arm, neck and shoulder massage easing tension and promoting relaxation followed by a facial Gua Sha massage to enhance circulation and sculpt facial structures.
    //   \n A nourishing mask is then applied tailored to your skins needs before a 30 minute session of Dermalux light therapy.
    //   \n Indulge in the Ultimate Radiance Renewal facial and experience the pinnacle of relaxation and transformation, as your skin emerges with a renewed, radiant glow that will leave you feeling truly rejuvenated.`,
    // },
    {
      id: "microneedling-facial",
      name: "Microneedling Facial",
      duration: "1 hour",
      price: 120,
      description: `Experience advanced skin rejuvenation with our Raffine Microneedling Facial—a results-driven treatment designed to restore, repair, and revitalise your skin from within, while delivering a deeply relaxing facial experience.
      \nYour treatment begins with a double cleanse and gentle steam, preparing the skin by removing impurities and softening the pores. Hot towel wraps are used throughout to enhance relaxation and comfort, followed by a targeted exfoliation to refine the skin’s surface and optimise results.
      \nUsing the innovative medical-grade Raffine device, precise micro-channels are created within the skin to stimulate the body’s natural healing response and boost collagen and elastin production. A targeted serum, selected specifically for your skin type and individual goals, is infused during the treatment to maximise results and deep product absorption.
      \nMicroneedling is highly effective in improving:
      \n- Fine lines and wrinkles
      - Acne scarring and imperfections
      - Enlarged pores
      - Uneven skin tone and texture
      \nFollowing the microneedling process, a soothing bio-cellulose mask is applied to deeply hydrate and calm the skin, while a relaxing chest massage enhances the overall treatment experience.
      \nYour facial also includes Dermalux LED light therapy, which works to reduce redness, support healing, and further stimulate collagen production for enhanced results.
      \nThe treatment is finished with a refreshing ice globe massage to soothe and tighten the skin, alongside the application of vitamins and minerals to nourish, protect, and leave your complexion glowing.
      \nSuitable for most skin types, this treatment delivers smoother, firmer, and more radiant skin with minimal downtime. You can expect an initial glow within days, with continued improvement as collagen production increases over time.`,
    },
    {
      id: "dermalux-skin-renewal",
      name: "Dermalux Skin Renewal",
      duration: "1 hour 10 mins",
      price: 75,
      description: `Experience deep skincare rejuvenation with our Dermalux Skin Renewal, a luxurious treatment that cares for your skin from start to finish. This begins with a thorough cleanse and steam to open your pores, followed by a gentle exfoliation and a relaxing neck, shoulder and face massage. A nourishing mask, tailored to your skin's specific needs, is then applied.
      \nThe treatment culminates in a 30-minute session under the Dermalux Light — a clinically proven LED light therapy technology that targets a range of skin concerns, from acne to fine lines, to enhance your skin's radiance and support a more even, youthful complexion.`,
    },
    {
      id: "dermalux-light-therapy",
      name: "Dermalux Light Therapy",
      duration: "30 mins",
      price: 35,
      description: `A 30-minute Dermalux Light Therapy session using advanced, clinically proven LED technology to stimulate your skin's natural rejuvenation processes. This non-invasive treatment targets a range of skin concerns, from acne to fine lines, leaving your complexion looking calmer, clearer and more radiant — a quick, relaxing treatment with no downtime, on its own or as an add-on.`,
    },
    {
      id: "radiance-brightening-facial",
      name: "Radiance Brightening Facial",
      duration: "1 hour",
      price: 65,
      description: `For clients experiencing pigmentation, photodamage, a tired complexion, dullness, or skin affected by seasonal changes. This treatment awakens the skin's natural glow and brightens areas of discolouration, combining a renewing enzyme exfoliation with an anti-glycation, brightening peel-off mask. The treatment also includes an upper body massage of the chest, neck, arms and hands.`,
    },
    {
      id: "radiance-deep-hydration-facial",
      name: "Radiance Deep Hydration Facial",
      duration: "1 hour",
      price: 65,
      description: `This facial treatment is designed to restore water levels in all layers of the skin, to deeply nourish and rehydrate the skin. It is suitable for those suffering from dry, dehydrated, and ageing skin. With the use of a comforting cleanser, resurfacing exfoliation, and an intense recovery mask to cocoon the skin, you can expect to leave feeling instantly hydrated.
      \nThis treatment may be particularly suitable if you are experiencing skin changes due to the menopause.
      \nAll of our facial treatments are inclusive of a facial steam, hot towel wrap, and a chest, neck and facial massage.`,
    },
    {
      id: "radiance-pore-refining-facial",
      name: "Radiance Pore Refining Facial",
      duration: "1 hour",
      price: 65,
      description: `This facial is suitable for open pores and oily and congested skin. During this treatment, we combine superior deep cleansing actives to aid the strengthening of the pore wall, and stimulate blood flow to refine the skin's texture. With the use of time release glycolic pads, followed by a purifying charcoal mask, the facial is designed to target and tackle the appearance of enlarged pores. It is inclusive of a deep enzymatic exfoliation, and a facial massage which will release facial tension.
      \nAll of our facial treatments are inclusive of a facial steam, hot towel wrap, and a chest, neck and facial massage.`,
    },
    {
      id: "radiance-calming-facial",
      name: "Radiance Calming Facial",
      duration: "1 hour",
      price: 65,
      description: `A professional treatment to soothe and comfort sensitised and irritated skin. This facial instantly calms inflamed, flushed, red, sensitive skin using intelligent formulations to aid skin recovery. A light drainage massage is carried out to stimulate blood circulation, and an instantly cooling Bio-Cellulose Mask packed with hyaluronic acid is applied, to help reduce inflammation and restore the skins natural barrier.
      \nThis treatment may be particularly suitable if you are experiencing skin changes due to the menopause or have a sensitive, reactive skin type.
      \nAll of our facial treatments are inclusive of a facial steam, hot towel wrap, and a chest, neck and facial massage.`,
    },
    {
      id: "dermaplaning-deluxe",
      name: "Dermaplaning Deluxe",
      duration: "1 hour",
      price: 65,
      description: `Our classic dermaplaning exfoliation, upgraded into a full facial experience. The same thorough dermaplaning treatment — removing dead skin and vellus hair for smoother, brighter skin — followed by a nourishing mask and relaxing facial massage to finish.`,
    },
    {
      id: "dermaplaning",
      name: "Dermaplaning",
      duration: "1 hour",
      price: 35,
      description:
        "A deep exfoliation using a sterile scalpel to remove up to 21 days of dead skin and vellus hair, allowing products to penetrate deeper for better results. The facial includes a double cleanse, steam, dermaplaning procedure, exfoliation, facial massage, ice globes, and a mask.\n\nThe benefits include:\n\n- Smoother makeup application\n- Immediate glowing results\n- Improved skin texture\n- Removes dead skin\n- Removes peach fuzz",
    },
    {
      id: "consultation-treatment",
      name: "Consultation & Treatment",
      duration: "1 hour 15 mins",
      price: "Varies",
      description: `Are you looking to start your skincare journey but unsure what your skin needs or where to begin? Book in for our consultation and treatment package where we will discuss your concerns and skincare goals, formulating both an in-clinic and at home treatment plan to help you achieve your skin goals.
      \nWith this package, we will carry out your first treatment right after your consultation.
      \nThere is no obligation to come up with a treatment plan, if you are just looking for a skin pick-me-up rather than a course of treatments, we will analyse your skin to see what treatment it needs on the day.
      \nThe price of this treatment varies, depending on the treatment your skin needs.`,
    },
  ],
  chemicalPeels: [
    {
      id: "biorepeel",
      name: "Biorepeel",
      duration: "50 mins",
      price: 80,
      description: `Biorepeel is a 2 phase chemical peel that harnesses the power of natural ingredients to rejuvenate the skin. It combines a blend of organic acids, enzymes and vitamins to gently exfoliate the skin, removing dead skin cells and impurities while stimulating collagen production.
      \nThe treatment is perfect for acne, scarring, pigmentation, fine lines, wrinkles, large pores, dull complexion and uneven texture, and it's formulated to suit all skin types.
      \nThe treatment is inclusive of a cleanse, steam, peel application, hydrating mask, chest massage, Dermalux light therapy and vitamins/ minerals.
      \nThere is minimal to no downtime, with most clients experiencing only mild tingling during treatment.`,
    },
  ],
  skinBoosters: [
    {
      id: "profhilo-face-and-neck",
      name: "Profhilo - Face + Neck (Save £30)",
      duration: "45 mins",
      price: 330,
      description: `Profhilo is an injectable anti-ageing treatment made from hyaluronic acid. The unique thing about Profhilo is that it is a bio-remodelling treatment which has one of the highest concentrations of hyaluronic acid on the market. It works by stimulating the production of collagen and elastin in the skin, giving you a plumper, more glowing complexion.
      \nIt can be used on the face, neck, decollete, arms, hands and knees, or any part of your body where the skin shows visible signs of ageing. There is an immediately noticeable improvement in skin tone, hydration as well as firmness, and lines are minimised. 2 sessions are required 4 weeks apart with an advised top up treatment every 6 months.
      \nAlthough you will notice immediate effects from this treatment the best results will be visible around 4 weeks after your second treatment.`,
    },
    {
      id: "profhilo-face",
      name: "Profhilo - Face",
      duration: "30 mins",
      price: 180,
      description: `Profhilo is an injectable anti-ageing treatment made from hyaluronic acid. The unique thing about Profhilo is that it is a bio-remodelling treatment which has one of the highest concentrations of hyaluronic acid on the market. It works by stimulating the production of collagen and elastin in the skin, giving you a plumper, more glowing complexion.
      \nIt can be used on the face, neck, decollete, arms, hands and knees, or any part of your body where the skin shows visible signs of ageing. There is an immediately noticeable improvement in skin tone, hydration as well as firmness, and lines are minimised. 2 sessions are required 4 weeks apart with an advised top up treatment every 6 months.
      \nAlthough you will notice immediate effects from this treatment the best results will be visible around 4 weeks after your second treatment.`,
    },
    {
      id: "profhilo-neck",
      name: "Profhilo - Neck",
      duration: "30 mins",
      price: 180,
      description: `Profhilo is an injectable anti-ageing treatment made from hyaluronic acid. The unique thing about Profhilo is that it is a bio-remodelling treatment which has one of the highest concentrations of hyaluronic acid on the market. It works by stimulating the production of collagen and elastin in the skin, giving you a plumper, more glowing complexion.
      \nIt can be used on the face, neck, decollete, arms, hands and knees, or any part of your body where the skin shows visible signs of ageing. There is an immediately noticeable improvement in skin tone, hydration as well as firmness, and lines are minimised. 2 sessions are required 4 weeks apart with an advised top up treatment every 6 months.
      \nAlthough you will notice immediate effects from this treatment the best results will be visible around 4 weeks after your second treatment.`,
    },
    {
      id: "seventy-hyal-4ml",
      name: "Seventy Hyal - Face / Neck 4ml",
      duration: "30 mins",
      price: 180,
      description: `Seventy Hyal is a bio stimulating injectable hyaluronic acid, otherwise known as a skin booster. It aims to improve hydration as well as stimulate the production of collagen and improve elastin. This skin booster acts as the perfect treatment if you are looking to improve your skin texture, add volume and improve skin laxity.
      \nIt can help with:
      - Loss of skin tone
      - Skin sagging
      - Skin ageing
      - Wrinkles and fine lines
      - Dark circles
      - Sun damage
      - Acne scarring
      - Lack of hydration
      \nThe perfect facial enhancement to create glowing skin.
      \nIt is recommended to have a course of 2-3 treatments 14 days apart.`,
    },
    {
      id: "seventy-hyal-2ml",
      name: "Seventy Hyal - Face / Neck 2ml",
      duration: "30 mins",
      price: 100,
      description: `Seventy Hyal is a bio stimulating injectable hyaluronic acid, otherwise known as a skin booster. It aims to improve hydration as well as stimulate the production of collagen and improve elastin. This skin booster acts as the perfect treatment if you are looking to improve your skin texture, add volume and improve skin laxity.
      \nIt can help with:
      - Loss of skin tone
      - Skin sagging
      - Skin ageing
      - Wrinkles and fine lines
      - Dark circles
      - Sun damage
      - Acne scarring
      - Lack of hydration
      \nThe perfect facial enhancement to create glowing skin.
      \nIt is recommended to have a course of 2-3 treatments 14 days apart.`,
    },
  ],
  vitaminInjections: [
    {
      id: "vitamin-b12-injection",
      name: "Vitamin B12 Injection",
      duration: "15 mins",
      price: 25,
      description: `Vitamin B12 is an essential vitamin that enables normal functioning of the brain, nervous system and red blood cells, and supports normal immune system function. A B12 deficiency can occur at any point in your life and may present with some of the following symptoms: mood swings, confusion, forgetfulness, fatigue, depression, headaches, weight gain/loss and reduced physical stamina. For healthy individuals, vitamin B12 injections will improve overall cerebral functioning, physical and psychological wellbeing as well as a healthier cardiovascular system.
      \nThe treatment involves an intramuscular injection which is a quick and easy process. The consultation and procedure will take no more than 15 minutes.
      \nSome of the benefits of this treatment include:
      - Improves sleep quality
      - Provides energy boost
      - Improves concentration
      - Supports the immune system
      - Boosts the metabolism`,
    },
    {
      id: "biotin-injection",
      name: "Biotin Injection",
      duration: "15 mins",
      price: 25,
      description: `Biotin (Vitamin B7) is an essential nutrient that supports the body's production of keratin, the protein that makes up hair, skin and nails. A quick intramuscular injection, taking no more than 15 minutes including consultation.
      \nSome of the benefits of this treatment include:
      - Supports stronger, healthier-looking hair
      - Supports skin health and condition
      - Supports stronger nails
      - Quick and easy, with no downtime`,
    },
  ],
  skinConsultation: [
    {
      id: "skin-consultation",
      name: "Free Skin Consultation",
      duration: "20 mins",
      price: "Free",
      description: `Not sure where to start, or just not ready to book a treatment yet? Come in for a free, relaxed 20-minute chat about your skin — no professional treatment on the day, and absolutely no obligation to book one afterwards.
      \nWe'll talk through whatever is on your mind, take a look at your skin, and explore what options might help, so you can leave feeling informed rather than under pressure.
      \nThis is the perfect first step if you're feeling nervous about visiting a clinic for the first time, curious about a treatment you've seen, or simply want an honest opinion before committing to anything.`,
    },
  ],
  medik8Consultation: [
    {
      id: "medik8-consultation",
      name: "Free Medik8 Product Consultation",
      duration: "20 mins",
      price: "Free",
      description: `If you're looking to start your skincare journey or change the products you are currently using, but don't want any professional treatments right now, why not come in and see me to discuss an at-home treatment plan.
      \nAny recommended products will be available to purchase in clinic.
      \nThere is no obligation to purchase any products if you decide this is not for you, that's okay!`,
    },
  ],
  addOns: [
    {
      id: "dermaplaining-add-on",
      name: "Dermaplaining (Add-On)",
      duration: "15 mins",
      price: 15,
      description: `Add Dermaplaining to your treatment.`,
    },
    {
      id: "microneedling-neck-add-on",
      name: "Microneedling Neck (Add-On)",
      duration: "15 mins",
      price: 15,
      description: `This service is an add on to the Microneedling facial. Please only book as an add on to a Microneedling facial.`,
    },
    {
      id: "microneedling-chest-add-on",
      name: "Microneedling Chest (Add-On)",
      duration: "15 mins",
      price: 15,
      description: `This service is an add on to the Microneedling facial. Please only book as an add on to a Microneedling facial.`,
    },
  ],
  bodyTreatments: [
    {
      id: "back-relaxation-ritual",
      name: "Back Relaxation Ritual",
      duration: "45 mins",
      price: 45,
      description: `Rejuvenate your back with our luxurious back facial treatment.
      \nA treatment designed to target the skin on your back, which is often neglected. The 45 minutes session includes cleansing, steaming, exfoliating scrub, hot towel wrap, tailored mask, mini back massage and vitamins and minerals.
      \nThe process helps unclog pores, removes dead skin and leaves your back feeling refreshed and revitalised.
      \nThe treatment is suitable to everyone, with or without skin concerns.`,
    },
  ],
};

export const serviceCategories = [
  { key: "advancedFacials", title: "Advanced Facials" },
  { key: "chemicalPeels", title: "Chemical Peels" },
  { key: "skinBoosters", title: "Skin Boosters" },
  { key: "vitaminInjections", title: "Vitamin Injections" },
  { key: "medik8Consultation", title: "Medik8 Product Consultation" },
  { key: "skinConsultation", title: "Free Skin Consultation" },
  { key: "addOns", title: "Add-Ons" },
  // { key: "bodyTreatments", title: "Body Treatments" },
];

export const advancedFacialServices = servicesData.advancedFacials.filter(
  (service) => service.id !== "microneedling-facial"
);

export const microneedlingServices = [
  ...servicesData.advancedFacials.filter(
    (service) => service.id === "microneedling-facial"
  ),
  ...servicesData.addOns.filter((service) =>
    service.id.startsWith("microneedling")
  ),
];

const categoryDescriptions = {
  advancedFacials:
    "Explore our range of advanced facial treatments, tailored to rejuvenate, restore, and enhance your natural radiance.",
  microneedling:
    "Experience advanced skin rejuvenation with our Raffine Microneedling treatments, designed to restore, repair, and revitalise your skin from within.",
  chemicalPeels:
    "Reveal smoother, brighter skin with our professional chemical peel treatments, designed to target texture, pigmentation, and signs of ageing.",
  skinBoosters:
    "Boost hydration, elasticity, and glow with our injectable skin booster treatments, including Profhilo and Seventy Hyal.",
  vitaminInjections:
    "Support your wellbeing from within with quick and effective vitamin injection treatments.",
  medik8Consultation:
    "Not sure where to start with your skincare? Book a free Medik8 product consultation for personalised at-home advice.",
  skinConsultation:
    "Nervous about booking, or just not ready to commit? Book a free, no-obligation 20-minute chat about your skin concerns.",
  addOns:
    "Enhance your treatment with our optional add-ons, available to complement selected services.",
};

const categorySlugs = {
  advancedFacials: "advanced-facials",
  chemicalPeels: "chemical-peels",
  skinBoosters: "skin-boosters",
  vitaminInjections: "vitamin-injections",
  medik8Consultation: "medik8-consultation",
  skinConsultation: "skin-consultation",
  addOns: "add-ons",
};

// Unique per-page meta descriptions so each treatment page has its own
// search snippet instead of sharing the site-wide default (see
// useDocumentMeta) — this is what lets a Profhilo or Microneedling ad land
// on a page Google recognises as relevant to that specific treatment.
const metaDescriptions = {
  advancedFacials:
    "Advanced facial treatments in Hindley, Wigan from £35. Nurse-led facials for pigmentation, hydration, pore refinement and sensitised skin.",
  microneedling:
    "Microneedling in Hindley, Wigan from £120, with package pricing available. Nurse-led treatment using a medical-grade device for acne scarring, fine lines and enlarged pores.",
  chemicalPeels:
    "Professional chemical peels in Hindley, Wigan from £80. Nurse-led Biorepeel treatment to target texture, pigmentation and early signs of ageing.",
  skinBoosters:
    "Profhilo and Seventy Hyal skin booster treatments in Hindley, Wigan from £100. Nurse-led hyaluronic acid injections for hydration, elasticity and glow.",
  vitaminInjections:
    "Vitamin B12 and Biotin injections in Hindley, Wigan from £25. Quick, nurse-led treatments to support energy, mood and overall wellbeing.",
  medik8Consultation:
    "Book a free Medik8 skincare consultation in Hindley, Wigan. Personalised at-home product advice from a qualified nurse, plus 15% off in-clinic.",
  skinConsultation:
    "Free 20-minute skin consultation in Hindley, Wigan. A relaxed, no-obligation chat with a qualified nurse about your skin concerns — no treatment, no pressure.",
  addOns:
    "Optional treatment add-ons at Radiance Aesthetics, Hindley, Wigan — enhance your facial, microneedling or dermaplaning session.",
};

export const treatmentPages = [
  {
    slug: categorySlugs.advancedFacials,
    title: "Advanced Facials",
    description: categoryDescriptions.advancedFacials,
    metaDescription: metaDescriptions.advancedFacials,
    services: advancedFacialServices,
  },
  {
    slug: "microneedling",
    title: "Microneedling",
    description: categoryDescriptions.microneedling,
    metaDescription: metaDescriptions.microneedling,
    services: microneedlingServices,
  },
  ...serviceCategories
    .filter(({ key }) => key !== "advancedFacials")
    .map(({ key, title }) => ({
      slug: categorySlugs[key],
      title,
      description: categoryDescriptions[key],
      metaDescription: metaDescriptions[key],
      services: servicesData[key],
    })),
];

export const treatmentNavLinks = [
  ...treatmentPages.map(({ slug, title }) => ({
    to: `/treatments/${slug}`,
    label: title,
  })),
  { to: "/treatments", label: "All Treatments" },
];
